module.exports = __webpack_public_path__ + "img/driscolls.af5164c0.png";